import { render, staticRenderFns } from "./SettingUser.vue?vue&type=template&id=1cc4938f&scoped=true&"
import script from "./SettingUser.vue?vue&type=script&lang=js&"
export * from "./SettingUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc4938f",
  null
  
)

export default component.exports